import {
  LOAD_CHATROOMS_SUCCESS,
  LOAD_CHATROOMS_ERROR,
  LOAD_CHATROOMS_BY_ID,
} from "../Types/chatroom.contants";

const INITIAL_STATE = {
  loading: false,
  chatrooms: [],
  error: null,
};

export const chatroomListReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case LOAD_CHATROOMS_BY_ID:
      return { ...state, loading: true, chatrooms: [] };
    case LOAD_CHATROOMS_SUCCESS:
      return {
        ...state,
        loading: false,
        chatrooms: action.payload,
      };
    case LOAD_CHATROOMS_ERROR:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
